<div class="bg-white border flex justify-start gap-5 rounded-r-md shadow-md h-full" [ngClass]="getFeedbackBorderColors">
    <div [ngClass]="getFeedbackBorderBackgroundColors()" class="w-2"></div>
    <div class="py-4 pr-6 w-full items-center" [ngClass]="{ 'flex justify-start gap-3': !header, 'justify-between': header }">
        <div class="flex items-center">
            <iota-icon [icon]="getFeedbackIcon()" [ngClass]="getFeedbackMessageColors()" class="rounded-full" size="1.5"></iota-icon>
            <ng-container *ngIf="header">
                <p class="ml-2 font-bold">{{ header }}</p>
            </ng-container>
        </div>
        <div class="w-full flex justify-between items-center">
            <p [ngClass]="{ 'ml-[32px] mt-1': header }">
                {{ message }} <span class="font-bold">{{ date }}</span>
            </p>
            <iota-icon
                *ngIf="showCloseIcon"
                class="cursor-pointer min-w-[30px]"
                icon="x-mark"
                size="1.5"
                (click)="onCloseMessageClick()"
            ></iota-icon>
        </div>
    </div>
</div>
